/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-unresolved */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { ChangeEvent, useState, FormEvent, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './popUp.module.scss';
import {
  LoginInterface,
  POP_UP_LOGIN_TYPE,
  PopUpLoginInterface,
} from './popUpTypes';
import '../../constants/_global.scss';
import { ReactComponent as XIcon } from '../../assets/x.svg';
import Input from '../../UI/input/inputComponent';
import { INPUT_TYPE } from '../../UI/input/inputTypes';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import { useDispatch, useSelector } from '../../index';
import { setError, signin } from '../../service/UserData';
import { LOCAL_STORAGE } from '../../constants/constants';

const PopUpLogin: React.FC<PopUpLoginInterface> = ({
  type,
  error,
  onClose,
  onNoAccount,
  onSubmit,
}) => {
  const suggestedText = 'Чтобы разместить объявление, авторизуйтесь';
  const onClickText = 'Войти';
  const err = useSelector((state) => state.userData.error);
  const dispatch = useDispatch();
  const text = {
    suggestedTitle: 'Чтобы разместить объявление, авторизуйтесь',
    onClickTitle: 'Войти',
    emailErrText: 'Неверный Email',
    passwordErrText: 'Неверный Пароль',
    placeholderEmail: 'Введите Email',
    placeholderPassword: 'Пароль',
    remindPass: 'Забыли пароль?',
    submitText: 'Войти',
    noAccountButon: 'Нет аккаунта',
  };

  const resolution = {
    DesktopOrLaptop: useMediaQuery({ minWidth: 620 }),
  };

  const [formData, setFormData] = useState<LoginInterface>({
    email: ' ',
    password: ' ',
  });

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const bodyData = {
      email: formData.email.toLowerCase(),
      password: formData.password,
    };

    const resultAction = await dispatch(signin(bodyData));

    if (signin.rejected.match(resultAction)) {
      console.log(
        'Login failed:',
        resultAction.payload || resultAction.error.message
      );
    } else if (signin.fulfilled.match(resultAction)) {
      onSubmit(1);
      dispatch(setError(null));
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form
      className={resolution.DesktopOrLaptop ? styles.shell : styles.shellMobile}
      onSubmit={handleSubmit}
    >
      <div className={styles.titleRow}>
        <h1 className="h1" style={{ marginTop: '16px' }}>
          {type === POP_UP_LOGIN_TYPE.ON_CLICK ? onClickText : suggestedText}
        </h1>
        {resolution.DesktopOrLaptop ? (
          <button type="button" className={styles.XBtn} onClick={onClose}>
            <XIcon />
          </button>
        ) : null}
      </div>
      <div className={styles.inputColumn}>
        <Input
          ver={INPUT_TYPE.REGULAR}
          errStatus={err !== null}
          errMessage={err !== null ? err : ''}
          placeholder={text.placeholderEmail}
          customWidth={!resolution.DesktopOrLaptop ? 620 : 472}
          name="email"
          onChange={handleChange}
        />
        <Input
          ver={INPUT_TYPE.PASSWORD}
          errStatus={err !== null}
          errMessage={' '}
          placeholder={text.placeholderPassword}
          customWidth={!resolution.DesktopOrLaptop ? 620 : 312}
          name="password"
          onChange={handleChange}
        />
      </div>
      <button type="button" className={`${styles.spanButton} spanGlobal`}>
        {text.remindPass}
      </button>
      <div
        className={
          resolution.DesktopOrLaptop ? styles.buttonRow : styles.buttonColumn
        }
      >
        <Button
          ver={BUTTON_VER.primary}
          type={BUTTON_TYPE.Submit}
          customWidth={!resolution.DesktopOrLaptop ? 620 : 111}
          text={text.submitText}
          onClick={() => handleSubmit}
        />
        <Button
          ver={BUTTON_VER.secondary}
          type={BUTTON_TYPE.Button}
          text={text.noAccountButon}
          customWidth={!resolution.DesktopOrLaptop ? 620 : 166}
          onClick={onNoAccount}
        />
      </div>
    </form>
  );
};

export default PopUpLogin;
